import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStageLayoutMainDeleteCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomStageLayoutMainDeleteCmd.validationSchema()
  );

  constructor(readonly cmd: RoomStageLayoutMainDelete) {
    JsonSchemaValidator.assert(RoomStageLayoutMainDeleteCmd.validation, cmd);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      }
    };
  }
}

interface RoomStageLayoutMainDelete {
  roomId: RoomId;
}
